import { render, staticRenderFns } from "./PoolOption.vue?vue&type=template&id=5ea87406&scoped=true&"
import script from "./PoolOption.vue?vue&type=script&lang=js&"
export * from "./PoolOption.vue?vue&type=script&lang=js&"
import style0 from "./PoolOption.vue?vue&type=style&index=0&id=5ea87406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea87406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea87406')) {
      api.createRecord('5ea87406', component.options)
    } else {
      api.reload('5ea87406', component.options)
    }
    module.hot.accept("./PoolOption.vue?vue&type=template&id=5ea87406&scoped=true&", function () {
      api.rerender('5ea87406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/theme/components/PoolOption.vue"
export default component.exports